import {use} from 'react'
import {CommentsContext, type ViewMode} from './CommentsContext'
import {isReviewCommentsViewMode} from './CommentsViewControls'

/**
 * Whether a single thread is being shown in detail rather than the list of comments.
 *
 * @param filteredThreadIds When provided, detail mode is only reported while the selected
 * thread still matches the active filter.
 */
export function isThreadDetailMode(
  viewMode: ViewMode,
  selectedThreadId: string | undefined,
  filteredThreadIds?: Set<string>,
): boolean {
  if (!isReviewCommentsViewMode(viewMode) || !selectedThreadId) return false

  return filteredThreadIds === undefined || filteredThreadIds.has(selectedThreadId)
}

/**
 * Context-backed variant of {@link isThreadDetailMode}, for components rendered inside
 * `CommentsContext`.
 */
export function useIsThreadDetailMode(filteredThreadIds?: Set<string>): boolean {
  const {viewMode, detailThreadId} = use(CommentsContext)

  return isThreadDetailMode(viewMode, detailThreadId, filteredThreadIds)
}
